import type { FailedInvoiceDeliveriesReportItem } from '@vy/types';
import { isNotEmptyArray } from '@vy/utils';
import { useCallback, useState } from 'react';
import type { FilterLineType } from '../../../../components/new-design/vyTableFilter';
import { matchesStringSelection } from '../../reports-components/shared-filter-fields';
import { FAILED_DELIVERIES_FILTER_FIELD_IDS } from './use-failed-deliveries-filter-fields';

type FilterPredicate = (item: FailedInvoiceDeliveriesReportItem, value: unknown) => boolean;

const FIELD_PREDICATES: Record<string, FilterPredicate> = {
  [FAILED_DELIVERIES_FILTER_FIELD_IDS.CUSTOMER]: (item, value) =>
    matchesStringSelection(item.customer.name, value),

  [FAILED_DELIVERIES_FILTER_FIELD_IDS.REASON]: (item, value) =>
    matchesStringSelection(item.reason ?? 'Email could not be delivered', value),
};

export function useFailedDeliveriesFilters() {
  const [filters, setFilters] = useState<FilterLineType[]>([]);

  const handleFilterChange = useCallback((filterLines: FilterLineType[]) => {
    setFilters(filterLines);
  }, []);

  return { filters, handleFilterChange };
}

export function applyFailedDeliveriesFilters(
  rows: FailedInvoiceDeliveriesReportItem[],
  filters: FilterLineType[],
): FailedInvoiceDeliveriesReportItem[] {
  if (!isNotEmptyArray(filters)) {
    return rows;
  }

  return rows.filter((item) =>
    filters.every((filter) => {
      const predicate = FIELD_PREDICATES[filter.field];

      if (!predicate) {
        return true;
      }

      return predicate(item, filter.value);
    }),
  );
}
